import axios from "../api";
import { CRYPTO_TOKEN_SECRET_KEY } from "../config";
import CryptoJS from "crypto-js";

const getAuthToken = () => {
    const decryptedData = CryptoJS.AES.decrypt(
        localStorage.getItem("token"),
        CRYPTO_TOKEN_SECRET_KEY
    ).toString(CryptoJS.enc.Utf8);

    return decryptedData;
};

export const getOrganizations = async (
    currentPage,
    searchValue,
    pageSize,
    status,
    byUser
) => {
    let apiUrl = `/api/organization?page=${currentPage}&searchValue=${searchValue}&pageSize=${pageSize}`;
    if (status) {
        apiUrl += `&status=${status}`;
    }
    return new Promise((resolve, reject) => {
        axios
            .get(apiUrl)
            .then((response) => resolve(response.data))
            .catch((error) => {
                reject(error);
            });
    });
}

export const updateInvoiceStatus = async (id, status) => {
    return axios.post("/api/organization/update-invoice-status", {
        id,
        status,
    });
};

export const sendInvoiceAction = async (orgId) => {

    const authToken = getAuthToken();

    const headers = {
        Authorization: `Bearer ${authToken}`,
    };

    return new Promise((resolve, reject) => {
        axios
            .post(
                "/api/organization/send",
                { orgId },
                { headers }
            )
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const verifyDomain = async (data) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`/api/organization/verify-domain-url`, data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getBusinessType = async () => {
    return new Promise((resolve, reject) => {
        axios
            .get(`/api/organization/business-type`)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};


